import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'remixicon/fonts/remixicon.css';
import './tailwind.css';
import './style.scss';
import './styles/list-page.css';
import App from './App.vue';
import router from './router';
import { vPermission } from '@/directives/permission';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(Antd);
app.directive('permission', vPermission);
app.mount('#app');
